import { Control, FieldError, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';
import { Dropdown } from 'components/Form/Dropdown/Dropdown';

import { EditableDocumentUnderstandingAgentSections, PRICE_STRATEGY_OPTIONS } from '../../../helpers';

type PriceStrategySectionProps = {
  control: Control<EditableDocumentUnderstandingAgentSections>;
  error?: FieldError;
  disabled: boolean;
};

export const PriceStrategySection = ({ control, error, disabled }: PriceStrategySectionProps) => {
  const { t } = useTranslation();
  const { field } = useController({ name: 'extraction.prices_strategy', control });

  return (
    <Section.Horizontal
      title={t('settings:documentUnderstandingAgent.global.priceStrategy.title')}
      description={t('settings:documentUnderstandingAgent.global.priceStrategy.description')}
    >
      <Dropdown
        options={PRICE_STRATEGY_OPTIONS}
        value={field.value}
        onChange={field.onChange}
        errors={error}
        disabled={disabled}
        dropdownDisplayTestId="price-strategy-dropdown"
      />
    </Section.Horizontal>
  );
};

/**
 * i18n keys
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.disabled')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.document')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.documentAndMasterData')
 * t('settings:documentUnderstandingAgent.global.priceStrategy.strategy.masterData')
 */
